var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8DF0E359-FF67-4D5F-A09E-9FDEDEF952E5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-PLP",
    transform: "translate(-1190.000000, -3288.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 0,
    y: 160,
    width: 1920,
    height: 3408
  }), /*#__PURE__*/React.createElement("g", {
    id: "Paginator",
    transform: "translate(1030.000000, 3288.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow/Right",
    transform: "translate(160.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5671545,4.02982337 L11.5814564,4.04354372 L17.2064564,9.66854374 C17.3012766,9.76336393 17.346982,9.88870014 17.3435726,10.0129391 C17.3436346,10.018324 17.3437501,10.0247726 17.3437501,10.03125 C17.3437501,10.2450403 17.2179581,10.4274916 17.0410164,10.4989856 L11.5814564,15.9564564 C11.3983981,16.1395146 11.101602,16.1395146 10.9185438,15.9564564 C10.7401793,15.7780919 10.7356058,15.4917476 10.9048234,15.3078457 L10.9185438,15.2935438 L15.67925,10.53125 L3.12500002,10.53125 C2.86611654,10.53125 2.65625001,10.3073924 2.65625001,10.03125 C2.65625001,9.76138364 2.85668555,9.5414524 3.10742671,9.53159492 L15.74325,9.53125002 L10.9185438,4.70645633 C10.7401793,4.52809187 10.7356058,4.24174751 10.9048234,4.05784562 L10.9185438,4.04354372 C11.0969082,3.86517926 11.3832526,3.86060581 11.5671545,4.02982337 Z",
    id: "Combined-Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRight);
export default __webpack_public_path__ + "static/media/pagination-right.bef5d3c1.svg";
export { ForwardRef as ReactComponent };